import React, { useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import BrandLogo from './BrandLogo';

export default function Navigation() {
  const [mobOpen, setMobOpen] = useState(false);

  return (
    <>
      <nav id="nav">
        <HashLink smooth to="/#hero" className="logo-a" onClick={() => setMobOpen(false)}>
          <span className="logo-panel">
            <BrandLogo placement="nav" />
          </span>
        </HashLink>

        <ul className="nav-ul">
          <li>
            <HashLink smooth to="/#solutions">
              Solutions
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="/#trends">
              Trend Intel
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="/#innovation">
              Innovation
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="/#sustainability">
              Sustainability
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="/#markets">
              Markets
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="/#gallery">
              Gallery
            </HashLink>
          </li>
          <li>
            <HashLink smooth to="/contact" className="nav-cta">
              Contact
            </HashLink>
          </li>
        </ul>
        <button
          type="button"
          className="burger"
          aria-label="Open menu"
          onClick={() => setMobOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      <div id="mob" className={mobOpen ? 'open' : ''} role="dialog" aria-modal="true">
        <div className="logo-panel logo-panel--mob">
          <BrandLogo placement="nav" />
        </div>
        <HashLink smooth to="/#solutions" onClick={() => setMobOpen(false)}>
          Solutions
        </HashLink>
        <HashLink smooth to="/#trends" onClick={() => setMobOpen(false)}>
          Trend Intel
        </HashLink>
        <HashLink smooth to="/#innovation" onClick={() => setMobOpen(false)}>
          Innovation
        </HashLink>
        <HashLink smooth to="/#sustainability" onClick={() => setMobOpen(false)}>
          Sustainability
        </HashLink>
        <HashLink smooth to="/#markets" onClick={() => setMobOpen(false)}>
          Markets
        </HashLink>
        <HashLink smooth to="/#gallery" onClick={() => setMobOpen(false)}>
          Gallery
        </HashLink>
        <HashLink smooth to="/contact" onClick={() => setMobOpen(false)}>
          Contact
        </HashLink>
      </div>
    </>
  );
}
